import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { Color } from 'ng2-charts';
import 'chartjs-plugin-labels';
@Component({
  selector: 'app-sentiment-overview',
  templateUrl: './sentiment-overview.component.html',
  styleUrls: ['./sentiment-overview.component.scss']
})
export class SentimentOverview implements OnInit {

  @Input() dataReport: any
  sentimentCount = 0;
  negPostCount = 0;
  posPostCount = 0;
  neuPostCount = 0;

  widthPos :any =  '0%';
  widthNeg :any = '0%';
  widthNeu :any = '0%';

  title_report = 'Sắc thái thảo luận';

  
  negPost = '';
  posPost = '';
  neuPost = '';
  public doughnutChartOptions: any = {
    plugins: {
      labels: {
        render: 'percentage',
        fontColor: 'black',
        position: 'outside',
        precision: 1,
        arc: true,
        fontSize: 12,
        textMargin: 4,
        fontStyle: 'bold'
      }
    }
  }
  public doughnutChartType = 'doughnut';

  public doughnutChartLabels = ['Tích cực', 'Tiêu cực', 'Trung tính'];
  public doughnutChartData = [
    [0,0,0]
  ];
  public doughnutChartColors: Color[] = [
    { backgroundColor: ["#00b050", "#c00000", "#bfbfbf"] }
  ];



  constructor() {
    console.log(this.dataReport)
  }

  ngOnInit(): void {
  };

  ngOnChanges(changes: SimpleChanges) {
    console.log(this.dataReport)
    this.mappingData()
  }
 
  async mappingData() {
    if(this.dataReport && this.dataReport.data) {
      if(this.dataReport.report_title) {
        this.title_report = this.dataReport.report_title;
      }
      if(this.dataReport.data.sentiment && this.dataReport.data.sentiment['pos']) {
        this.doughnutChartData = [(this.dataReport.data.sentiment.pos || 0 ), (this.dataReport.data.sentiment.neg || 0 ), (this.dataReport.data.sentiment.neu || 0 ) ];
       
       
        this.negPostCount = this.dataReport.data.sentiment.neg || 0;
        this.posPostCount = this.dataReport.data.sentiment.pos || 0;
        this.neuPostCount = this.dataReport.data.sentiment.neu || 0 ;
        this.sentimentCount = this.negPostCount + this.posPostCount +  this.neuPostCount ;

        this.widthPos = ((this.posPostCount/this.sentimentCount) * 100).toFixed(2) + '%';
        this.widthNeg = ((this.negPostCount/this.sentimentCount) * 100).toFixed(2) + '%';
        this.widthNeu = ((this.neuPostCount/this.sentimentCount) * 100).toFixed(2) + '%';

        this.negPost = this.dataReport['data'].negPost;
          this.posPost = this.dataReport['data'].posPost;
          this.neuPost = this.dataReport['data'].neuPost;
      }

    }
  }
}



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/views/reports-component/sentiment-overview/sentiment-overview.component.ts